import Vue from 'vue';
import Vuex from 'vuex';

import eventos from './modules/eventos'
import participante from './modules/participante'
import settings from './modules/settings'
import user from './modules/user'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        eventos,
        participante,
        settings,
        user
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js